import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=6103a9b0&scoped=true"
import script from "./archive.vue?vue&type=script&lang=js"
export * from "./archive.vue?vue&type=script&lang=js"
import style0 from "./archive.vue?vue&type=style&index=0&id=6103a9b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103a9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6103a9b0')) {
      api.createRecord('6103a9b0', component.options)
    } else {
      api.reload('6103a9b0', component.options)
    }
    module.hot.accept("./archive.vue?vue&type=template&id=6103a9b0&scoped=true", function () {
      api.rerender('6103a9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/archive/zh_TW/archive.vue"
export default component.exports